/** Texts of catalogs (docs/architecture/catalogs.md). */
export const catalogsDe = {
  title: 'Kataloge',
  description:
    'Auswahllisten der Firma mit ihren Eigenschaften. Formulare bieten nur aktive Einträge an.',
  count_one: '{{count}} Eintrag',
  count_other: '{{count}} Einträge',
  edit: '„{{name}}“ bearbeiten',
  none: 'Keine Auswahl',
  choose: 'Bitte wählen',
  inactive: 'Inaktiv',
  default: 'Standard',
  deletedEntry: 'Gelöschter Eintrag',
  yes: 'Ja',
  no: 'Nein',
  colors: {
    none: 'Keine Farbe',
    blue: 'Blau',
    sky: 'Himmelblau',
    teal: 'Petrol',
    green: 'Grün',
    lime: 'Hellgrün',
    amber: 'Bernstein',
    orange: 'Orange',
    red: 'Rot',
    rose: 'Rosé',
    violet: 'Violett',
    slate: 'Schiefergrau',
  },
  fields: {
    name: 'Name',
    code: 'Kürzel',
    color: 'Farbe',
    description: 'Beschreibung',
    isDefault: 'Standard',
    active: 'Aktiv',
    status: 'Status',
  },
  page: {
    search: 'Einträge durchsuchen',
    searchPlaceholder: 'Name, Kürzel oder Text',
    status: 'Status',
    statuses: { active: 'Aktiv', inactive: 'Inaktiv' },
    allOf: '{{field}}: alle',
    withoutValue: 'Ohne Angabe',
    new: 'Neuer Eintrag',
    empty: 'Noch keine Einträge',
    emptyHint: 'Einträge anlegen, aus einer Datei importieren oder die Standardinhalte übernehmen.',
    emptyReadOnly: 'Einträge legen Personen an, die die Einstellungen des Moduls ändern dürfen.',
    noMatches: 'Keine Einträge gefunden',
    noMatchesHint: 'Suche ändern oder Filter entfernen.',
    range: '{{from}}–{{to}} von {{total}}',
    moveUp: '„{{name}}“ nach oben',
    moveDown: '„{{name}}“ nach unten',
    moved: '„{{name}}“ steht jetzt an Position {{position}} von {{count}}.',
    remove: '„{{name}}“ löschen',
    removeTitle: '„{{name}}“ löschen?',
    removeDescription:
      'Der Eintrag wird nicht mehr angeboten. Datensätze, die ihn verwenden, zeigen ihn weiter an. Wer ihn nur nicht mehr anbieten will, setzt ihn auf inaktiv.',
    removed: '„{{name}}“ gelöscht',
  },
  dialog: {
    newTitle: 'Neuer Eintrag',
    editTitle: 'Eintrag bearbeiten',
    defaultHint: 'Wird in Formularen vorausgewählt. Nur ein Eintrag kann Standard sein.',
    activeHint:
      'Inaktive Einträge werden nicht mehr angeboten. Datensätze, die sie verwenden, zeigen sie weiter an.',
    created: '„{{name}}“ angelegt',
    saved: '„{{name}}“ gespeichert',
  },
  import: {
    action: 'Importieren',
    title: 'Einträge importieren',
    description:
      'JSON-Datei mit einer Liste von Einträgen, höchstens 1 MB. Der Abgleich läuft über den Namen: Neue Namen werden angelegt, bestehende Einträge übernehmen die Werte aus der Datei.',
    choose: 'Datei auswählen',
    chosen: 'Datei: {{name}}',
    deactivateMissing: 'Einträge deaktivieren, die nicht in der Datei stehen',
    checking: 'Die Datei wird geprüft …',
    preview: 'Beim Import passiert Folgendes:',
    counts: {
      created: 'Neu',
      updated: 'Geändert',
      unchanged: 'Unverändert',
      deactivated: 'Deaktiviert',
      unresolved: 'Verweise ohne Treffer',
      skipped: 'Übersprungen',
    },
    countsHint:
      'Verweise auf Einträge, die es im anderen Katalog nicht gibt, bleiben leer. Neue Einträge, denen ein Pflichtverweis fehlt, werden übersprungen.',
    submit: 'Importieren',
    done: 'Import abgeschlossen: {{created}} neu, {{updated}} geändert, {{deactivated}} deaktiviert.',
    invalidFile: 'Die Datei enthält keine Liste von Einträgen im JSON-Format.',
    tooLarge: 'Die Datei ist zu groß. Möglich ist höchstens 1 MB.',
    invalidEntry: 'Eintrag {{number}}: {{message}}',
    invalidValue: 'Wert ungültig ({{field}})',
  },
  defaults: {
    load: 'Standardinhalte übernehmen',
    title: 'Standardinhalte übernehmen?',
    description:
      'Legt die Einträge der Standardinhalte an, die es noch nicht gibt. Bestehende Einträge bleiben, wie sie sind.',
    confirm: 'Übernehmen',
    done_one: '{{count}} Eintrag angelegt',
    done_other: '{{count}} Einträge angelegt',
    nothing: 'Die Standardinhalte sind schon vollständig vorhanden.',
    unresolved_one: '{{count}} Verweis fand keinen passenden Eintrag und blieb leer.',
    unresolved_other: '{{count}} Verweise fanden keinen passenden Eintrag und blieben leer.',
    skipped_one: '{{count}} Eintrag fehlt, weil sein Pflichtverweis keinen Treffer fand.',
    skipped_other: '{{count}} Einträge fehlen, weil ihr Pflichtverweis keinen Treffer fand.',
  },
  errors: {
    exists: 'Einen Eintrag mit diesem Namen gibt es schon.',
    limit:
      'Der Katalog hat die Höchstzahl an Einträgen erreicht. Nicht mehr benötigte Einträge löschen, um Platz zu schaffen.',
    reference: 'Diesen Eintrag gibt es nicht mehr. Bitte einen anderen wählen.',
    required: 'Pflichtfeld',
    inactiveDefault: 'Ein inaktiver Eintrag kann nicht Standard sein.',
    duplicateName: 'Der Name kommt in der Datei mehrfach vor.',
    multipleDefaults: 'Nur ein Eintrag kann Standard sein.',
    number: 'Bitte eine Zahl angeben.',
    orderChanged: 'Die Liste hat sich inzwischen geändert. Sie zeigt jetzt den aktuellen Stand.',
  },
};
